import { get } from "@/shared/utils/fetchApi";
import { Plan } from "../types/subscription-types";

interface PlansResponse {
  success: boolean;
  data: Plan[];
}

interface PlanResponse {
  success: boolean;
  data: Plan;
}

export const PlanService = {
  /**
   * Lista todos os planos disponíveis
   */
  async getPlans(params?: {
    is_active?: boolean;
    slug?: string;
  }): Promise<PlansResponse> {
    const queryParams = new URLSearchParams();
    if (params?.is_active !== undefined) {
      queryParams.append("is_active", String(params.is_active));
    }
    if (params?.slug) {
      queryParams.append("slug", params.slug);
    }

    const query = queryParams.toString();
    const endpoint = query ? `/plans?${query}` : "/plans";

    // v2 retorna Plan[] flat (sem envelope); legacy retorna { success, data }.

    const rows = await get<Plan[]>(endpoint);
    return { success: true, data: rows ?? [] };
  },

  /**
   * Busca um plano por ID
   */
  async getPlanById(id: string): Promise<PlanResponse> {
    return { success: true, data: await get<Plan>(`/plans/${id}`) };
  },

  /**
   * Busca um plano por slug
   */
  async getPlanBySlug(slug: string): Promise<PlanResponse> {
    return { success: true, data: await get<Plan>(`/plans/slug/${slug}`) };
  },
};
